import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { groupBy, keyBy } from 'lodash';
import NodeTree from './NodeTree.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiTree',
  props: {
    nodes: { default: () => [] },
    editing: { type: Boolean, default: false },
    idKey: { default: 'id' },
    parentKey: { default: 'parentId' }
  },
  setup(__props: any) {

const props = __props as { nodes: Array<any>, editing: boolean, idKey: string, parentKey: string }



const nodesParentsMap = computed(() => groupBy(props.nodes, props.parentKey));

const nodesMap = computed(() => keyBy(props.nodes, props.idKey));

const parents = computed(() => props.nodes.filter(
    (node) => !node[props.parentKey] || !nodesMap.value[node[props.parentKey]],
));

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(parents), (node) => {
    return (_openBlock(), _createBlock(NodeTree, {
      key: node[__props.idKey],
      editing: __props.editing,
      "nodes-parents-map": _unref(nodesParentsMap),
      node: node,
      lvl: 0,
      "id-key": __props.idKey
    }, {
      default: _withCtx(({ data, lvl }) => [
        _renderSlot(_ctx.$slots, "default", {
          data: data,
          lvl: lvl,
          dataId: data[__props.idKey]
        })
      ]),
      _: 2
    }, 1032, ["editing", "nodes-parents-map", "node", "id-key"]))
  }), 128))
}
}

})